<template>
    <div>
        <div class="clearfix">

            <span class="textLabel managingLabel"
                  :class="{active : tabModule.managingTabIndex === 0}"
                  @click="tabModule.managingTabIndex = 0">
                职位管理
            </span>

            <span class="textLabel managingLabel"
                  :class="{active : tabModule.managingTabIndex === 1}"
                  @click="tabModule.managingTabIndex = 1">
                求职列表
            </span>

            <span class="textLabel managingLabel"
                  :class="{active : tabModule.managingTabIndex === 2}"
                  @click="tabModule.managingTabIndex = 2">
                简历推荐
            </span>

            <span class="textLabel managingLabel"
                  :class="{active : tabModule.managingTabIndex === 3}"
                  @click="tabModule.managingTabIndex = 3">
                简历搜索
            </span>

        </div>
        <div style="padding-top: 24px">
            <!-- 职位管理列表 -->
            <div v-show="tabModule.managingTabIndex === 0">
                <jobList ref="jobList"/>
            </div>

            <!-- 求职列表 -->
            <div v-show="tabModule.managingTabIndex === 1">
                <jobRequestList ref="jobRequestList"/>
            </div>

            <!--  简历推荐 -->
            <div v-show="tabModule.managingTabIndex === 2">
                <button class="reloadResume" @click="reloadResumeRecommend">
                    <i class="icon reloadResumeIcon" style="margin-right: 4px;"></i> 刷新简历
                </button>
                <resumeRecommend ref="resumeRecommend"/>
            </div>

            <!--  简历搜索 -->
            <div v-show="tabModule.managingTabIndex === 3">
                <resumeBrowse ref="resumeBrowse"/>
            </div>
        </div>
    </div>
</template>

<script>

import jobList          from "./jobList";
import jobRequestList   from "./jobRequestList";
import resumeRecommend  from "./resumeRecommend";
import resumeBrowse     from "./resumeBrowse";

export default {
    name: "managingCenter",
    components : {
        jobList, jobRequestList, resumeRecommend, resumeBrowse
    },
    data() {
        return {
            tabModule: {
                managingTabIndex: 0
            },
        }
    },
    methods : {
        reloadResumeRecommend(){
            this.$refs.resumeRecommend.reloadDataList();
        },

        onReachBottom() {
            switch (this.tabModule.managingTabIndex)
            {
                case 0 :
                    this.$refs.jobList.loadNextPage();
                    break;
                case 1 :
                    this.$refs.jobRequestList.loadNextPage();
                    break;
                case 2 :
                    this.$refs.resumeRecommend.loadNextPage();
                    break;
                case 3 :
                    this.$refs.resumeBrowse.loadNextPage();
                    break;

            }
        }
    }
}
</script>

<style lang="scss" scoped>

.managingLabel {
    background: hsla(0, 0%, 96%, 1);
    color: hsla(220, 15%, 76%, 1);
    line-height: 26px;
    height: 26px;
    border-radius: 19px;
    margin-right: 12px;
    padding: 0 10px;

    &.active {
        background: hsla(36, 100%, 64%, 1);
        color: white;
    }
}

.reloadResume{
    width: 100%;
    height: 30px;
    background: #FDFDFD;
    border: 1px solid #F5F5F5;

    border-radius: 4px;
    font-size: 14px;
    color: #9B9C9F;
    margin-bottom: 24px;
    text-align: center;
    line-height: 27px;
}

.reloadResumeIcon{
    width: 12px;
    height: 12px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAYCAYAAAARfGZ1AAADcElEQVRIS+2VTWgcdRjGn+c/m6RNQ02hpdCiBfEgqETqpX6ATVOtpyqCVlGETWdnTTYG8VC0UghWEPxoJLIxM7MzsUoFc/GgEgoqWpFU26IHFQ8WRYOooamt1SSbmf8jmw9M6jadg0fnOs/7e595v4ZY4XklijY1JtwDhx2E2gg0S3BEnKd0DMKolLxdLBb/WooplyvXlErud6zHDsNwo2gOEnwIYPOl8gsCgZ8s7IGi6x6u6Qb9yj05Y47Iovtf8CCIbwE5QmJzLRjCBKj3YHXC0pwh6RhpPYjbAewCuAZACundanXq4VxuVY9xzHOyen4ZvOxH7Q2GoySbAE1CeKpanXqzVCpdqOd+cPDIulzjzH6CjwFoknRUVmPGMX3L4EHw2nWg/Zxks6RPZnO8v5TP/7JSTxbfheHwNhCjAFol/U6ydTk8jE+SvEnSKUN7p+u6k1nAixrf92+gafyMxOq5clrMlyWM4wdh+YakBOI2z8t/mQXs+1G7JbYsah2DXYR5QBJk9cIcPAjiD2nYLmsHPW9vKRM4im4zMh8BcJbqF4agNgj7a3AGYfQ1yKsTpdu7C4XjWeB9fX2NmzZf+SKWOF8SN97gmKfnnEdR1Jam3OB5ne9nAWfV1F2irMGX0/0Pr1uh/7Qs5fJIS67hwjOG6aFCoTDOIIhflsFdprZTZCKraZLnIc0kSg53ed7I5Rr3zxmIB0F2yepZz+s8wKAS/0Zww/z5JGrbRc5/kGQ/9gp7t2eB9/f3t65pueI0yRYi3eG67qcMK/FZCa0AElm7j+SPc1vnANWpqQ96enrOZIEHleglwjxhpXeKhc7dtRgGleFzkNbWzAr4psFhRz7jNVxMOhTGdxvgLQDTacIbu7ryPyzA43MQavCvAF4v4YQsHikW899mcexXKvcZOK8DMImd3d3leUcX4xiEw5OA1tnU7nRy5iDAmwH8YWUPGdhXC4XCr/WS+H68FQb7DHkvgKqFHi+6nZWlWoZhPCFgPZG2GWO+T4UyYfYAaAT0J8DjgsYkTFB2NYzZCGAHgWsBNkk4bZl2Puq6xy42waEgCgy5NZmdvqO7u/vswgneSepJ0NwKYFUd5ymgn0ENVaenBy71G5ybuYGBgabe3t6ZiyG+719lTEOHhbZAXEuDFOC4TdIvyHSsWCzOrtSXvwEH4IlUkHTHfQAAAABJRU5ErkJggg==");
}
</style>
